// src/components/Sidebar.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  BarChart3, 
  Users, 
  Target, 
  UserCheck, 
  GitMerge,
  MessageSquare, 
  Clock3,
  Settings,
  Shield,
  Home,
  Radar,
  Bot,
  Briefcase
} from 'lucide-react';

const Sidebar = () => {
  const location = useLocation();

  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: Home },
    { name: 'Users', href: '/users', icon: Users },
    { name: 'Access Requests', href: '/access-requests', icon: Clock3 },
    { name: 'Advertisers', href: '/advertisers', icon: Target },
    { name: 'Affiliates', href: '/affiliates', icon: UserCheck },
    { name: 'Overlap', href: '/overlap', icon: GitMerge },
    { name: 'Contacts', href: '/contacts', icon: MessageSquare },
    { name: 'Lead Intelligence', href: '/discovery', icon: Radar },
    { name: 'Reporting', href: '/reporting', icon: BarChart3 },
    { name: 'Automations', href: '/automations', icon: Bot },
    { name: 'Management', href: '/management', icon: Briefcase },
    { name: 'Settings', href: '/settings', icon: Settings },
  ];

  const isActive = (href) => {
    if (href === '/dashboard') {
      return location.pathname === '/' || location.pathname === '/dashboard';
    }
    return location.pathname === href;
  };

  return (
    <div className="w-64 admin-glass border-r border-slate-700/50 flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-slate-700/50">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-gradient-to-r from-red-600 to-red-700 rounded-lg">
            <Shield className="h-6 w-6 text-white" />
          </div>
          <div>
            <span className="text-xl font-bold text-slate-100">SpaceJet</span>
            <span className="text-xl font-light text-red-400 ml-1">Admin</span>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-6 space-y-2">
        {navigation.map((item) => {
          const IconComponent = item.icon;
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200 ${
                isActive(item.href)
                  ? 'bg-red-600/20 text-red-400 border border-red-600/30'
                  : 'text-slate-300 hover:bg-slate-800/50 hover:text-slate-100'
              }`}
            >
              <IconComponent className="mr-3 h-5 w-5" />
              {item.name}
            </Link>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-slate-700/50">
        <div className="text-xs text-slate-400 text-center">
          SpaceJet Network Admin v1.0
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
